module.exports = __webpack_public_path__ + "img/Mod(API) scripts location.d09f399f.jpg";